import service from '@/services/superaccess'

const control_point = {
  state: {
    control_point_modal: false
  },
  mutations: {
    updateStatusCPointModal (state, status) {
      state.control_point_modal = status
    }
  },
  getters: {
    getStatusCPointModal (context) {
      return context.control_point_modal
    }
  },
  actions: {
    retriveControlPoints (context, payload) {
      return service.post('/api/control_point/list', context)
    },
    retriveCPointTypes (context, payload) {
      return service.post('/api/control_point/types', context)
    },
    saveControlPoint (context, payload) {
      return service.post('/api/control_point/create', context, { control_point: payload })
    },
    updateControlPoint (context, payload) {
      return service.patch('/api/control_point/modify', context, { control_point: payload })
    },
    changeCPointStatus (context, payload) {
      return service.patch('/api/control_point/inactive', context, payload)
    },
    setStatusCPointModal (context, payload) {
      context.commit('updateStatusCPointModal', payload)
    },
    syncControlPoints (context, payload) {
      return service.post('/api/control_point/sync', context, payload)
    }
  }
}

export default control_point



// WEBPACK FOOTER //
// app/javascript/src/store/control_point.js